var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0192 10.1715V7.0174C17.0192 4.24637 14.7728 2 12.0018 2V2C9.23074 2 6.98438 4.24636 6.98438 7.01739V10.1715",
    stroke: "#717680",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8804 10.2275H6.12109C5.01652 10.2275 4.12109 11.123 4.12109 12.2275V19.9999C4.12109 21.1045 5.01653 21.9999 6.1211 21.9999H17.8804C18.985 21.9999 19.8804 21.1045 19.8804 19.9999V12.2275C19.8804 11.123 18.985 10.2275 17.8804 10.2275Z",
    stroke: "#717680",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0022 16.2332C12.7585 16.2332 13.3716 15.6201 13.3716 14.8638C13.3716 14.1075 12.7585 13.4944 12.0022 13.4944C11.2459 13.4944 10.6328 14.1075 10.6328 14.8638C10.6328 15.6201 11.2459 16.2332 12.0022 16.2332Z",
    fill: "#717680"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0039 15.7505V17.973",
    stroke: "#717680",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock24Px);
export default __webpack_public_path__ + "static/media/Lock_24px.b3e5fe31a10f922e86a63770c455dffc.svg";
export { ForwardRef as ReactComponent };